import * as HoverCard from "@radix-ui/react-hover-card";
import type { User } from "@sa-nu/core-system/src/domain/extendedModels";
import { formatZonedDateTime, ZonedDateTime } from "@sa-nu/shared-utils/date";

import type { AccommodationAvailabilityBlock } from "../../../../../../__generated__/gql/graphql";
import { AutoLinkedText } from "../../../../ui/auto-linked-text";

export type BlockWithUser = Pick<
  AccommodationAvailabilityBlock,
  | "id"
  | "name"
  | "category"
  | "categoryInfo"
  | "isTentative"
  | "note"
  | "createdAt"
  | "updatedAt"
> & {
  createdByUser?: Pick<User, "name" | "email"> | null;
  updatedByUser?: Pick<User, "name" | "email"> | null;
};

function formatDateTime(zonedDateTimeString?: string | null): string | null {
  if (!zonedDateTimeString) return null;

  const zonedDateTime = ZonedDateTime.from(zonedDateTimeString);
  return formatZonedDateTime(zonedDateTime, { pad: true });
}

export function BlockHoverCardWrapper({
  block,
  children,
}: {
  block: BlockWithUser | null | undefined;
  children: React.ReactNode;
}) {
  if (!block) return <>{children}</>;
  return (
    <HoverCard.Root>
      <HoverCard.Trigger asChild>{children}</HoverCard.Trigger>
      <HoverCard.Portal>
        <HoverCard.Content
          className="z-50 rounded-md bg-white p-4 shadow-[hsl(206_22%_7%/35%)_0px_10px_38px_-10px,hsl(206_22%_7%/20%)_0px_10px_20px_-15px]"
          align="start"
          alignOffset={20}
        >
          <div className="space-y-2">
            <div>
              <p className="text-[11px]">ブロック名</p>
              <p className="text-[14px]">
                {block.isTentative && "⏸️ "}
                {block.name}
              </p>
            </div>
            <div>
              <p className="text-[11px]">種別</p>
              <p className="text-[14px] whitespace-normal">
                {block.categoryInfo.label}
              </p>
            </div>
            <div>
              <p className="text-[11px]">作成</p>
              <ul className="text-[14px]">
                <li>
                  👤{" "}
                  {block.createdByUser
                    ? `${block.createdByUser.name} (${block.createdByUser.email})`
                    : "不明"}
                </li>
                <li>🕘 {formatDateTime(block.createdAt) ?? "不明"}</li>
              </ul>
            </div>
            <div>
              <p className="text-[11px]">更新</p>
              <ul className="text-[14px]">
                <li>
                  👤{" "}
                  {block.updatedByUser
                    ? `${block.updatedByUser.name} (${block.updatedByUser.email})`
                    : "不明"}
                </li>
                <li>🕘 {formatDateTime(block.updatedAt) ?? "不明"}</li>
              </ul>
            </div>
            {block.note && (
              <div>
                <p className="text-[11px]">メモ</p>
                <p className="max-w-xs text-[14px] wrap-break-word whitespace-pre-wrap">
                  <AutoLinkedText text={block.note} />
                </p>
              </div>
            )}
          </div>
        </HoverCard.Content>
      </HoverCard.Portal>
    </HoverCard.Root>
  );
}
